import { render, staticRenderFns } from "./universityReport.vue?vue&type=template&id=58cfb9f7&scoped=true"
import script from "./universityReport.vue?vue&type=script&lang=js"
export * from "./universityReport.vue?vue&type=script&lang=js"
import style0 from "./universityReport.vue?vue&type=style&index=0&id=58cfb9f7&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cfb9f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58cfb9f7')) {
      api.createRecord('58cfb9f7', component.options)
    } else {
      api.reload('58cfb9f7', component.options)
    }
    module.hot.accept("./universityReport.vue?vue&type=template&id=58cfb9f7&scoped=true", function () {
      api.rerender('58cfb9f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printReport/universityReport/universityReport.vue"
export default component.exports